import React from 'react';
import { FileText } from 'lucide-react';
import { attachmentDisplayName, splitAttachmentUrls } from '../../constants/acceptedChatFiles';
import { classNames } from '../../utils/classNames';

const isSafeHttpUrl = (url) => /^https?:\/\//i.test(String(url || '').split('#')[0]);

export const ChatMessageAttachments = ({ urls = [], className = '' }) => {
  const { images, files } = splitAttachmentUrls((urls || []).filter(isSafeHttpUrl));
  if (!images.length && !files.length) {
    return null;
  }

  return (
    <div className={classNames('space-y-2', className)}>
      {images.length ? (
        <div className="grid gap-2 sm:grid-cols-2">
          {images.map((url) => (
            <a key={url} href={url} target="_blank" rel="noreferrer">
              <img src={url} alt="" className="w-full rounded-xl object-cover" />
            </a>
          ))}
        </div>
      ) : null}
      {files.length ? (
        <div className="flex flex-wrap gap-2">
          {files.map((url) => (
            <a
              key={url}
              href={url.split('#')[0]}
              target="_blank"
              rel="noreferrer"
              className="inline-flex max-w-[14rem] items-center gap-2 rounded-xl border border-neutral-200 bg-white px-2.5 py-2 text-xs text-neutral-700 dark:border-neutral-800 dark:bg-neutral-950 dark:text-neutral-200"
            >
              <FileText size={14} className="shrink-0 opacity-70" />
              <span className="truncate">{attachmentDisplayName(url)}</span>
            </a>
          ))}
        </div>
      ) : null}
    </div>
  );
};
